import { Box, Button, alpha, useTheme } from "@mui/material";
import CustomTooltip from "../../components/CustomTooltip";

/**
 * Demo component for CustomTooltip
 * Shows different configurations of the CustomTooltip component
 */
const CustomTooltipDemo = () => {
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="row" gap={2}>
      <CustomTooltip title="This is a tooltip">
        <Button variant="outlined" size="small" sx={{ borderRadius: 2 }}>
          Hover me
        </Button>
      </CustomTooltip>
      <CustomTooltip
        title="Custom styled tooltip"
        style={{ backgroundColor: alpha(theme.palette.primary.light, 0.1) }}
      >
        <Button variant="outlined" size="small" sx={{ borderRadius: 2 }}>
          Custom Style
        </Button>
      </CustomTooltip>
    </Box>
  );
};

export default CustomTooltipDemo;
